import axios from "../../helpers/httpClient";

export default {
    getOrders: async ({ commit, state, dispatch }) => {
        try {
            // Start loader
            commit('SET_LOADER', true);

            const orders = await axios.get(`/information/private/getOrders`, {
                params: {}}, {
                headers: { 'Content-Type': 'application/json' }
            })

            // Stop Loader
            commit('SET_LOADER', false);

            if (orders.status === 200) {
                commit('SET_ORDERS', orders.data.orders);
                commit('SET_ORDERS_FILTROS', orders.data.orders);
            }
        } catch (error) {
            // Stop Loader
            commit('SET_LOADER', false);

            console.log(error)
            if (error?.response) {
                console.log(error?.response)
                dispatch('activeMessageError', (error.response !== undefined)
                    ? error?.response?.data?.message || error?.response?.data?.msg
                    : 'ERROR'
                )
            } else {
                dispatch('activeMessageError', 'ERROR')
                console.log(error)
            }
            return
        }
    },

    addOrder: async ({ commit, state, dispatch }, payload) => {
        try {
            // Start loader
            commit('SET_LOADER', true);

            const stateOrders = state.orders;

            const orderAdded = await axios.post("/information/private/addOrder", payload)

            // Stop Loader
            commit('SET_LOADER', false);

            if (orderAdded.status === 200) {
                stateOrders.push(orderAdded.data.data)

                commit('SET_ORDERS', stateOrders);
                commit('SET_ORDERS_FILTROS', stateOrders);
                dispatch('activeMessageCorrect', orderAdded.data.message);
                return 'ok';
            }
        } catch (error) {
            // Stop Loader
            commit('SET_LOADER', false);

            console.log(error)
            if (error?.response) {
                console.log(error?.response)
                dispatch('activeMessageError', (error.response !== undefined)
                    ? error?.response?.data?.message || error?.response?.data?.msg
                    : 'ERROR'
                )
            } else {
                dispatch('activeMessageError', 'ERROR')
                console.log(error)
            }
            return
        }
    },

    confirmUserSubscription: async ({ commit, state, dispatch }, payload) => {
        try {
            // Start loader
            commit('SET_LOADER', true);

            const stateOrders = state.orders;

            const orderUpdated = await axios.post("/information/private/admin/confirmUserSubscription", payload)

            // Stop Loader
            commit('SET_LOADER', false);

            if (orderUpdated.status === 200) {
                const ind = stateOrders.findIndex(e => e.Id_pedido === orderUpdated?.data?.data?.Id_pedido);
                stateOrders.splice(ind, 1, orderUpdated.data.data);

                commit('SET_ORDERS', stateOrders);
                commit('SET_ORDERS_FILTROS', stateOrders);

                dispatch('activeMessageCorrect', 'Info updated')
            }
        } catch (error) {
            // Stop Loader
            commit('SET_LOADER', false);

            console.log(error)
            if (error?.response) {
                console.log(error?.response)
                dispatch('activeMessageError', (error.response !== undefined)
                    ? error?.response?.data?.message || error?.response?.data?.msg
                    : 'ERROR'
                )
            } else {
                dispatch('activeMessageError', 'ERROR')
                console.log(error)
            }
            return
        }
    },
}